export default {
  methods: {
    showChecklistsForWorksheet(worksheet) {
      return (worksheet?.checklists || []).length > 0
    }
  }
}
